import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {ApiClient} from '@forlabs/api-bridge';
import {DefaultDataServiceConfig, EntityCollectionServiceElementsFactory, HttpUrlGenerator} from '@ngrx/data';
import {Action, ScannedActionsSubject} from '@ngrx/store';
import {Observable} from 'rxjs';
import {EntityCollectionService, FollowMeDataService} from '../metadata';
import {CourseMessage, CourseMessageInterface} from './course-messages.models';


@Injectable()
export class CourseMessageCollectionService extends EntityCollectionService<CourseMessageInterface> {
  constructor(
    serviceElementsFactory: EntityCollectionServiceElementsFactory,
    @Inject(ScannedActionsSubject) scannedActions$: Observable<Action>,
  ) {
    super(CourseMessage, serviceElementsFactory, scannedActions$);
  }
}

@Injectable()
export class CourseMessageDataService extends FollowMeDataService<CourseMessageInterface> {
  constructor(
    apiClient: ApiClient,
    http: HttpClient,
    httpUrlGenerator: HttpUrlGenerator,
    config?: DefaultDataServiceConfig,
  ) {
    super(CourseMessage, apiClient, http, httpUrlGenerator, config);
  }
}
